import { Panel } from "rsuite";
import BasicPanel from "../basicPanel/basicPanel";

import "./doublePanel.css";

export default function DoublePanel({
    children,
    secondPanelBody,
    secondPanelHeader
}) {
    return (
        <Panel bordered bodyFill className="doublePanel">
            <div className="padded">
                { children }
            </div>
            <BasicPanel header={ secondPanelHeader }>
                { secondPanelBody }
            </BasicPanel>
        </Panel>
    )
}